import { proxy } from 'valtio';
import { ENVIRONMENT } from '@soundxyz/utils/const';
import { PersistenceStorage } from '@store/persistence';
import type { LandingFeaturedStatusState } from './schema';
import { FeaturedStatusEnum, LandingFeaturedStatusSchema } from './schema';

const version = '0.1';
const storageKey = `@soundxyz/landingFeaturedStatus${
  ENVIRONMENT === 'production' ? '' : '-' + ENVIRONMENT
}-${version}`;

export const LandingFeaturedStatusPersistence = PersistenceStorage({
  schema: LandingFeaturedStatusSchema,
  key: storageKey,
});

const initialLandingFeaturedStatusState = () =>
  ({
    recent: FeaturedStatusEnum.Enum.HOT,
    upcoming: FeaturedStatusEnum.Enum.HOT,
  }) satisfies LandingFeaturedStatusState;

export const landingFeaturedStatusState = proxy<LandingFeaturedStatusState>(
  initialLandingFeaturedStatusState(),
);
